import watchUtils = require("esri/core/watchUtils");
import GroupLayer = require("esri/layers/GroupLayer");
import MapImageLayer = require("esri/layers/MapImageLayer");
import BuildPopups from "./buildPopups";
import * as layerSource from "./layerSource";

export const nhsLayer = new MapImageLayer({
  url: layerSource.serverUrl,
  listMode: "hide-children",
  visible: false,
  minScale: 250000,
  sublayers: [
    {
      id: layerSource.NHSLayer
    }
  ]
});

export const jurisdictionLayer = new MapImageLayer({
  url: layerSource.serverUrl,
  listMode: "hide-children",
  visible: false,
  minScale: 250000,
  sublayers: [
    {
      id: layerSource.JurisdictionLayer
    }
  ]
});

export const functionalClassLayer = new MapImageLayer({
  url: layerSource.serverUrl,
  listMode: "hide-children",
  visible: false,
  minScale: 250000,
  sublayers: [
    {
      id: layerSource.FunctionalClassLayer
    }
  ]
});

export const significantRoutesWorkZoneSafetyandMobilityPolicyLayer = new MapImageLayer({
  url: layerSource.serverUrl,
  listMode: "hide-children",
  visible: false,
  minScale: 250000,
  sublayers: [
    {
      id: layerSource.SignificantRoutesWorkZoneSafetyandMobilityPolicyLayer
    }
  ]
});

export const speedLimitLayer = new MapImageLayer({
  url: layerSource.serverUrl,
  listMode: "hide-children",
  visible: false,
  minScale: 250000,
  sublayers: [
    {
      id: layerSource.SpeedLimitLayer
    }
  ]
});

export const DTRSMPostedStructuresLayer = new MapImageLayer({
  url: layerSource.serverUrl,
  listMode: "hide-children",
  visible: false,
  minScale: 600000,
  sublayers: [
    {
      id: layerSource.DTRSMPostedStructures
    }
  ]
});

export const DTRLMPostedStructuresLayer = new MapImageLayer({
  url: layerSource.serverUrl,
  listMode: "hide-children",
  visible: false,
  minScale: 600000,
  sublayers: [
    {
      id: layerSource.DTRLMPostedStructures
    }
  ]
});

export const DTRLocalTruckRouteLayer = new MapImageLayer({
  url: layerSource.serverUrl,
  listMode: "hide-children",
  visible: false,
  minScale: 600000,
  sublayers: [
    {
      id: layerSource.DTRLocalTruckRoute
    }
  ]
});

export const DTRSMTruckRouteLayer = new MapImageLayer({
  url: layerSource.serverUrl,
  listMode: "hide-children",
  visible: false,
  minScale: 600000,
  sublayers: [
    {
      id: layerSource.DTRSMTruckRoute
    }
  ]
});

export const DTRLMTruckRouteLayer = new MapImageLayer({
  url: layerSource.serverUrl,
  title: "DTR LM Truck Route",
  listMode: "hide-children",
  visible: false,
  minScale: 600000,
  sublayers: [
    {
      id: layerSource.DTRLMTruckRouteWith,
      title: "DTR LM Truck Route With",
      legendEnabled: true
    },
    {
      id: layerSource.DTRLMTruckRouteAgainst,
      title: "DTR LM Truck Route Against",
      legendEnabled: true
    },
  ]
});

export const roadwayClassificationGroupLayer = new GroupLayer({
  title: "Roadway Classification",
  id: "09 - Roadway Classification",
  visible: true,
  visibilityMode: "independent",
  layers: [
    DTRLMTruckRouteLayer,
    DTRSMTruckRouteLayer,
    DTRLocalTruckRouteLayer,
    DTRLMPostedStructuresLayer,
    DTRSMPostedStructuresLayer,
    speedLimitLayer,
    significantRoutesWorkZoneSafetyandMobilityPolicyLayer,
    functionalClassLayer,
    jurisdictionLayer,
    nhsLayer
  ]
});

roadwayClassificationGroupLayer.layers.forEach(layer => {
  watchUtils.whenTrueOnce(layer, "loaded", () => {
    if (layer instanceof MapImageLayer) {
      layer.loadAll().then(() => {
        if (layer.sublayers.length === 1) {
          layer.title = layer.sublayers.getItemAt(0).sourceJSON.name;
          layer.sublayers.getItemAt(0).title = layer.sublayers.getItemAt(0).sourceJSON.name;
        }
        BuildPopups.buildPopupIfLoaded(layer as MapImageLayer);
      });
    }
    // BuildPopups.buildPopupIfLoaded(layer as MapImageLayer);  // Don't enable popups
  });
});
